import { render } from "./DocumentNumber.vue?vue&type=template&id=14f1b1bd&scoped=true"
import script from "./DocumentNumber.vue?vue&type=script&lang=js"
export * from "./DocumentNumber.vue?vue&type=script&lang=js"

import "./DocumentNumber.vue?vue&type=style&index=0&id=14f1b1bd&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14f1b1bd"]])

export default __exports__